<div class="my-3 my-md-5">
    <div class="container-fluid">
        <div class="page-header">
            <span class="bold">User Status Wise Report</span>
        </div>
    </div>
    <div class="container-fluid px-4 pt-4 card">
        <mat-accordion class="example-headers-align" multi>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row mb-2 mt-2">
                    <div class="col-sm-3 mt-2">
                        <mat-select placeholder="Bds" [(ngModel)]="bd" (click)="setSearchValue('bds')" multiple
                            #itemSelect="ngModel">
                            <input class="mySearchInput" #bd_search focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'bds')"
                                (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                id="bd_search">
                            <mat-option value="{{bd.id}}" *ngFor="let bd of bds">{{bd.name}}</mat-option>
                        </mat-select>
                    </div>
                    <div class="col-sm-3 mt-2">
                        <mat-select placeholder="Catergory" [(ngModel)]="tcatergory">
                            <mat-option>All</mat-option>
                            <mat-option value="{{cat.id}}" *ngFor="let cat of treatCategory">{{cat.name}}</mat-option>
                        </mat-select>
                    </div>
                    <!-- <div class="col-sm-3 mt-2">
                        <mat-form-field appearance="fill">
                            <mat-label>Enter a date range (Max 7 Days)</mat-label>
                            <mat-date-range-input [rangePicker]="picker" [min]="minDate" [max]="maxDate">
                                <input matStartDate #dateRangeStart placeholder="Start date" (dateChange)="setMaxDate(dateRangeStart)">
                                <input matEndDate #dateRangeEnd placeholder="End date" (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
                            </mat-date-range-input>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-date-range-picker #picker></mat-date-range-picker>
                        </mat-form-field>
                        <mat-icon (click)="clearDate()">clear</mat-icon>

                    </div> -->
                    <div class="col-sm-3 mt-2">
                        <button type="button" class="btn btn-primary ml-2 mb-4" (click)="gettocReportList()"> <i
                                class="fa fa-search" aria-hidden="true"></i> Search Data</button>
                        <button type="button" class="btn btn-primary ml-2 mb-4" (click)="resetFilters()"> <i
                                class="fa fa-sync"></i> Reset Filters</button>
                    </div>

                </div>
            </mat-expansion-panel>
        </mat-accordion>
        <div class="card">
            <div class="table-responsive">
                <table class="table table-hover table-outline table-vcenter text-nowrap card-table">
                    <thead>
                        <tr class="text-center">
                            <th colspan="10">User Status Report of 
                                <span *ngIf="show_start_date"><b>{{show_start_date | date}}</b> to <b>{{show_end_date | date}}</b></span> 
                                <span *ngIf="!show_start_date"><b>{{todayDate | date }}</b></span>
                            </th>
                        </tr>
                        <tr class="text-center">
                            <th>BD NAME</th>
                            <th>FOLLOW UP'S</th>
                            <th>DNP'S</th>
                            <th>HOT LEAD</th>
                            <th>NEW LEAD</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="text-center" *ngFor="let reportData of userStatusReportList">
                            <td>{{reportData.name}}</td>
                            <td>{{reportData.followups_assigned ? reportData.followups_assigned : 0}}</td>
                            <td>{{reportData.dnps_assigned ? reportData.dnps_assigned : 0}}</td>
                            <td>{{reportData.hot_lead_assigned ? reportData.hot_lead_assigned : 0}}</td>
                            <td>{{reportData.new_lead_assigned ? reportData.new_lead_assigned : 0}}</td>
                        </tr>

                        <tr *ngIf="user_report_loading">
                            <td colspan="5" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                        </tr>
                        <tr *ngIf="loaded && !userStatusReportList.length">
                            <td colspan="5" class="text-center"><i class="far fa-frown"></i> Data not found</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>